import { Link } from "react-router-dom";
import { Check, Crown, Gift } from "lucide-react";

const PLANS = [
  { id: "free", name: "Gratuit", price: "0 €", per: "pour toujours", perks: ["2 histoires illustrées", "Quiz de compréhension", "Cartes de vocabulaire"], cta: "Créer un compte gratuit" },
  { id: "monthly", name: "Premium mensuel", price: "5,99 €", per: "TTC / mois", perks: ["Toutes les histoires", "Lecture à voix haute", "10 histoires créées par l'IA par mois", "Ateliers « Répète après moi » et « Raconte ! »"], cta: "Essayer 7 jours gratuits", trial: true },
  { id: "yearly", name: "Premium annuel", price: "49 €", per: "TTC / an", note: "Soit environ 4,08 € par mois, 2 mois offerts", perks: ["Tout le Premium", "Le meilleur prix"], cta: "Essayer 7 jours gratuits", trial: true, best: true },
];

function PlanCard({ plan, i }) {
  return (
    <div data-testid={`landing-plan-${plan.id}`} style={{ animationDelay: `${i * 90}ms` }}
      className={`rise card-paper relative flex flex-col p-7 ${plan.best ? "!border-[color:var(--terracotta)]" : ""}`}>
      {plan.best && <span className="absolute -top-3 left-6 rounded-full bg-[color:var(--terracotta)] px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white">Le plus choisi</span>}
      <h3 className="flex items-center gap-2 font-display text-2xl font-bold">{plan.trial && <Crown size={20} className="text-[color:var(--sun)]" />}{plan.name}</h3>
      <p className="mt-3"><span data-testid={`landing-plan-price-${plan.id}`} className="font-display text-5xl font-bold">{plan.price}</span> <span className="font-bold text-[color:var(--muted-ink)]">{plan.per}</span></p>
      {plan.note && <p className="mt-1 text-sm text-[color:var(--muted-ink)]">{plan.note}</p>}
      {plan.trial && <p className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-[color:var(--sun)] px-3 py-1 text-sm font-extrabold"><Gift size={14} /> 7 jours gratuits</p>}
      <ul className="mt-5 flex-1 space-y-2">
        {plan.perks.map((p) => <li key={p} className="flex items-start gap-2"><Check size={18} className="mt-0.5 shrink-0 text-[color:var(--sage)]" /> {p}</li>)}
      </ul>
      <Link to="/connexion?mode=register" data-testid={`landing-plan-cta-${plan.id}`} className={`mt-6 ${plan.best ? "btn-primary" : "btn-ghost"}`}>{plan.cta}</Link>
    </div>
  );
}

export default function Pricing() {
  return (
    <section id="tarifs" data-testid="landing-pricing" className="mt-28">
      <h2 className="font-display text-4xl font-bold sm:text-5xl">Des tarifs simples et clairs</h2>
      <p className="mt-3 max-w-2xl text-lg text-[color:var(--muted-ink)]">Commencez gratuitement. Passez à Premium quand vous voulez, avec 7 jours d'essai offerts.</p>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {PLANS.map((p, i) => <PlanCard key={p.id} plan={p} i={i} />)}
      </div>
      <p data-testid="landing-pricing-terms" className="mt-6 max-w-3xl text-sm text-[color:var(--muted-ink)]">
        Prix TTC, TVA incluse. Rien n'est prélevé pendant les 7 jours d'essai, qui sont offerts une seule fois par compte. Ensuite, l'abonnement se renouvelle automatiquement chaque mois ou chaque année. Vous pouvez l'annuler à tout moment, en un clic, depuis votre espace parent. Sans publicité.{" "}
        <Link to="/cgu-cgv" className="font-bold underline">Voir les CGV</Link>
      </p>
    </section>
  );
}
